import axios from 'axios'
import { API_URL } from '@/services/api'
import { getAuthToken } from '@/services/sessionProps'
import { handleCatch } from '@/helpers/axiosHelpers'

axios.defaults.headers.common = {
    Authorization: `Bearer ${getAuthToken()}`,
}

const ProductService = {
    async getProduct(id) {
        try {
            const response = await axios.get(`${API_URL}/api/products/${id}`)

            return response.data
        } catch (error) {
            handleCatch(error)
        }
    }
}

/* eslint-disable import/prefer-default-export */
export function getProductService() {
    return ProductService
}
